import Typography from "components/typography";
import React, { useState } from "react";

import { FaPause, FaPlay } from "react-icons/fa6";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { FormatAudioDuration } from "utils/dateConvert";

interface IProps {
  isPlaying: boolean;
  toggleVideo: () => void;
  duration: number;
  setRange: ({
    startTime,
    endTime
  }: {
    startTime: number;
    endTime: number;
  }) => void;
}
const Player = ({ isPlaying, toggleVideo, duration, setRange }: IProps) => {
  const [range1, setRange1] = useState(0);
  const [range2, setRange2] = useState(330 / duration);

  const maxDistance = 880 / duration; // 8 seconds
  const minDistance = 330 / duration; // 3 seconds

  const handleSlideOne = (e: any) => {
    const newValue = Number(e.target.value);

    if (
      range2 - newValue <= maxDistance &&
      newValue < range2 &&
      range2 - newValue >= minDistance
    ) {
      setRange1(newValue);
      const time = (newValue / 100) * duration;
      setRange({ startTime: time / duration, endTime: range2 });
    }
  };

  const handleSlideTwo = (e: any) => {
    const newValue = Number(e.target.value);

    if (
      newValue - range1 <= maxDistance &&
      newValue > range1 &&
      newValue - range1 >= minDistance
    ) {
      setRange2(newValue);
      const time = (newValue / 100) * duration;

      setRange({ startTime: range1, endTime: time });
    }
  };
  return (
    <Container>
      <Typography mt="2.4" weight="medium" color="white">
        Edit Duration
        <span style={{ color: Colors.grey500, fontWeight: "400" }}>
          (3-8 seconds)
        </span>
      </Typography>
      <PlayerContainer>
        <ToggleBtn onClick={toggleVideo}>
          {isPlaying ? (
            <FaPause color="black" size={10} />
          ) : (
            <FaPlay color="black" size={10} />
          )}
        </ToggleBtn>
        <AudioContainer>
          <AbsoulteText>
            <Typography size="s" color={Colors.yellow100}>
              {FormatAudioDuration((range1 / 100) * duration)} -
            </Typography>
            <Typography size="s" color={Colors.yellow100} ml="0.2">
              {FormatAudioDuration((range2 / 100) * duration)}
            </Typography>
          </AbsoulteText>
          <SliderTrack minvalue={range1} maxvalue={range2} />
          <SliderElement>
            <RangeInput
              min="0"
              max="100"
              value={range1}
              id="slider-1"
              onInput={handleSlideOne}
              step={1}
            />
          </SliderElement>

          <RangeInput
            min="0"
            max="100"
            value={range2}
            id="slider-2"
            onInput={handleSlideTwo}
            step={1}
          />
        </AudioContainer>
      </PlayerContainer>
    </Container>
  );
};

export default Player;

const Container = styled.div`
  margin-top: 1.6rem;
`;

const PlayerContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

const ToggleBtn = styled.div`
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${Colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AudioContainer = styled.div`
  position: relative;
  width: 80%;
  height: 2.8rem;
`;

const SliderElement = styled.div`
  position: relative;
  height: 2.8rem;
`;

const AbsoulteText = styled.div`
  position: absolute;
  top: -1.8rem;
  left: 0;
  display: flex;
  align-items: center;
`;

const SliderTrack = styled.div<{ minvalue: number; maxvalue: number }>`
  width: 100%;
  height: 100%;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: rgba(254, 198, 103, 0.1);
  background: ${(props) => `linear-gradient(to right, 
    rgba(254, 198, 103, 0.10) ${props.minvalue}%,
    ${Colors.yellow500} ${props.minvalue}%,
    ${Colors.yellow500} ${props.maxvalue}%,
    rgba(254, 198, 103, 0.10) ${props.maxvalue}%)`};
`;

const RangeInput = styled.input.attrs({ type: "range" })`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  outline: none;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: transparent;
  pointer-events: none;

  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    height: 5px;
  }

  &::-moz-range-track {
    -moz-appearance: none;
    height: 5px;
  }

  &::-ms-track {
    appearance: none;
    height: 5px;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 2.8rem;
    width: 1px;
    background-color: ${Colors.yellow500};
    cursor: pointer;
    margin-top: -9px;
    pointer-events: auto;
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    height: 1.7rem;
    width: 1.7rem;
    cursor: pointer;
    background-color: ${Colors.yellow500};
    pointer-events: auto;
    border: none;
  }

  &::-ms-thumb {
    appearance: none;
    height: 1.7em;
    width: 1.7em;
    cursor: pointer;

    background-color: ${Colors.yellow500};
    pointer-events: auto;
  }

  &:active::-webkit-slider-thumb {
    background-color: #ffffff;
    border: 1px solid ${Colors.yellow500};
  }
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
`;
